<dx-data-grid #prices
          keyExpr="id"
          class="flex-1 mt-3"
          [dataSource]="this.productPrices"
          [showBorders]="false"
          [showColumnLines]="false"
          [showRowLines]="false"
          [rowAlternationEnabled]="true"
          [columnAutoWidth]="true"
          [wordWrapEnabled]="true"
          height="auto"
          style="max-width: 1200px; max-height: 400px;"
        >
          <dxo-sorting mode="multiple"></dxo-sorting>
          <dxo-group-panel [visible]="false"></dxo-group-panel>
          <dxo-filter-row [visible]="false"></dxo-filter-row>
          <dxo-editing
            mode="row"
            [allowDeleting]="false"
            [allowUpdating]="false"
            [allowAdding]="false"
            [useIcons]="false"
          ></dxo-editing>
          <dxi-column dataField="productId" [caption]="'entity.price.productId' | translate | ucfirst">
            <dxo-lookup
              [dataSource]="products"
              displayExpr="name"
              valueExpr="id"
            ></dxo-lookup>
          </dxi-column>
          <dxi-column dataField="warehouseId" [caption]="'entity.price.rateId' | translate | ucfirst">
            <dxo-lookup
              [dataSource]="rates"
              displayExpr="name"
              valueExpr="id"
            ></dxo-lookup>
          </dxi-column>
          <dxi-column dataField="formatId" [caption]="'entity.price.formatId' | translate | ucfirst">
            <dxo-lookup
              [dataSource]="formats"
              displayExpr="name"
              valueExpr="id"
            ></dxo-lookup>
          </dxi-column>
          <dxi-column class="gs-gridColumn" dataField="scale" [caption]="'entity.price.seasonality.scale' | translate | ucfirst" dataType="number"></dxi-column>
          <dxi-column class="gs-gridColumn" dataField="price" [caption]="'entity.price.seasonality.price' | translate | ucfirst" dataType="number"></dxi-column>
          <dxi-column class="gs-gridColumn" dataField="expenses" [caption]="'entity.price.seasonality.expenses' | translate | ucfirst" dataType="number"></dxi-column>
          <dxi-column class="gs-gridColumn" dataField="price" [caption]="'entity.price.seasonality.price' | translate | ucfirst" dataType="number"></dxi-column>
          <dxi-column class="gs-gridColumn" dataField="discount1" [caption]="'entity.price.seasonality.discount1' | translate | ucfirst" dataType="number"></dxi-column>
          <dxi-column class="gs-gridColumn" dataField="discount2" [caption]="'entity.price.seasonality.discount2' | translate | ucfirst" dataType="number"></dxi-column>
          <dxi-column class="gs-gridColumn" dataField="dispatchPeriod" [caption]="'entity.price.seasonality.dispatchPeriod' | translate | ucfirst" dataType="number"></dxi-column>
          <dxi-column class="gs-gridColumn" dataField="priceStockFormat" [caption]="'entity.price.seasonality.priceStockFormat' | translate | ucfirst" dataType="number"></dxi-column>
</dx-data-grid>
